import { FormEvent, useState } from 'react'
import { Button, Card, Col, Container, Form, Row } from 'react-bootstrap'
import { useNavigate, useParams } from 'react-router-dom'
import { setSuperAdminToken } from '../helpers'

export default function SuperAdminPinCode() {
  const navigate = useNavigate()
  const { pendingToken } = useParams<{ pendingToken: string }>()

  const [pinCode, setPinCode] = useState('')
  const [loading, setLoading] = useState(false)
  const [errorText, setErrorText] = useState('')

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault()
    setErrorText('')

    if (!/^\d{6}$/.test(pinCode)) {
      setErrorText('Please enter a valid 6-digit PIN code.')
      return
    }

    try {
      setLoading(true)
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/super-admin/pincode-validation`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ pendingToken, pinCode: Number(pinCode) }),
        }
      )

      const body = await response.json()

      if (body?.err === 'pinCodeExpired') {
        setErrorText('PIN code has expired. Please log in again.')
        return
      }

      if (body?.err === 'invalidPinCode') {
        setErrorText('Invalid PIN code. Please try again.')
        return
      }

      if (!response.ok || !body?.token) {
        setErrorText('Verification failed. Please try again.')
        return
      }

      setSuperAdminToken(body.token)
      navigate('/super-admin')
    } catch {
      setErrorText('Network error.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <Container className='py-5'>
      <Row className='justify-content-center'>
        <Col md={6} lg={4}>
          <Card>
            <Card.Body>
              <h4 className='mb-1'>Super Admin</h4>
              <p className='text-muted mb-3 small'>
                A PIN code has been sent to your email address.
              </p>
              <Form onSubmit={handleSubmit}>
                <Form.Group className='mb-3'>
                  <Form.Label>PIN Code</Form.Label>
                  <Form.Control
                    type='text'
                    inputMode='numeric'
                    maxLength={6}
                    value={pinCode}
                    onChange={e => setPinCode(e.target.value.replace(/\D/g, ''))}
                    autoComplete='one-time-code'
                    autoFocus
                    placeholder='6-digit code'
                  />
                </Form.Group>

                {!!errorText && <p className='text-danger mb-3'>{errorText}</p>}

                <div className='d-flex justify-content-between align-items-center'>
                  <Button
                    variant='link'
                    className='p-0 text-secondary'
                    onClick={() => navigate('/super-admin/login')}
                  >
                    Back to login
                  </Button>
                  <Button type='submit' disabled={loading}>
                    {loading ? 'Verifying...' : 'Verify'}
                  </Button>
                </div>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}
